import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Grid, Menu, MenuItem } from "@mui/material";
import { Button } from "@totalsoft/rocket-ui";
import { useTranslation } from "react-i18next";
import { fileType } from "constants/fileTypes";

const HeaderComponent = ({ searching, onSearch, onDownload }) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const toggleDownload = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = fileType => () => {
    onDownload(fileType);
  };

  return (
    <Grid container justifyContent="end" gap={1}>
      <Menu id="render-export-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {/* <MenuItem onClick={handleDownload(fileType.excel)}>{t('PartnerList.ExportExcel')}</MenuItem> */}
        <MenuItem onClick={handleDownload(fileType.csv)}>{t("PartnerList.ExportCsv")}</MenuItem>
      </Menu>
      <Button color="primary" tooltip={t("Tooltips.DownloadLogsList")} onClick={toggleDownload} ref={ref}>
        {t("Logs.Export")}
      </Button>
      <Button color="primary" onClick={onSearch} disabled={searching}>
        {searching ? t("Searching") + "..." : t("Search")}
      </Button>
    </Grid>
  );
};

HeaderComponent.propTypes = {
  onSearch: PropTypes.func.isRequired,
  searching: PropTypes.bool,
  onDownload: PropTypes.func.isRequired
};

export default HeaderComponent;
